import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaRegEye } from "react-icons/fa";
import { IoEyeOffOutline } from "react-icons/io5";
import axios from "axios";
import "./AlumniLogin.css";

axios.defaults.withCredentials = true;

const AlumniLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const [formMessage, setFormMessage] = useState(location.state?.message || "");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (location.state?.message && !formMessage) {
      setFormMessage(location.state.message);
    }
  }, [location.state, formMessage]);

  const validateForm = () => {
    const nextErrors = {};

    if (!email.trim()) {
      nextErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      nextErrors.email = "Enter a valid email address";
    }

    if (!password) {
      nextErrors.password = "Password is required";
    } else if (password.length < 6) {
      nextErrors.password = "Password must be at least 6 characters";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleChange = (setter, field) => (e) => {
    setter(e.target.value);
    setErrors((prev) => ({ ...prev, [field]: "" }));
    setFormMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setFormMessage("");
    setErrors({});

    const emailClean = email.trim();

    try {
      const response = await axios.post("/backend/auth/login", {
        email: emailClean,
        password,
      });

      if (response.data?.user) {
        // Redirect to the correct dashboard based on role returned by backend
        const role = response.data.user.role;
        if (role === "admin") {
          navigate("/admin-dashboard", { replace: true });
        } else {
          navigate("/pjc-dashboard", { replace: true });
        }
        return;
      }
    } catch (loginErr) {
      const message =
        loginErr?.response?.data?.message ||
        "Invalid email or password. Please check your credentials.";
      setErrors({ form: message });
    }

    setIsSubmitting(false);
  };

  return (
    <div className="alumni-login-page">
      <div className="alumni-login-card">
        <h1 className="alumni-login-title">PJC FUND LOGIN</h1>
        <div className="alumni-login-line"></div>

        {formMessage && <p className="alumni-page-message">{formMessage}</p>}
        {errors.form && <p className="alumni-page-message error">{errors.form}</p>}

        <form onSubmit={handleSubmit}>
          <div className="alumni-input-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={handleChange(setEmail, "email")}
              aria-invalid={Boolean(errors.email)}
            />
            {errors.email && <p className="alumni-field-error">{errors.email}</p>}
          </div>

          <div className="alumni-input-group">
            <label htmlFor="password">Password</label>
            <div className="alumni-password-box">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={handleChange(setPassword, "password")}
                aria-invalid={Boolean(errors.password)}
              />
              <button
                type="button"
                className="alumni-eye-btn"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <IoEyeOffOutline size={22} /> : <FaRegEye size={20} />}
              </button>
            </div>
            {errors.password && <p className="alumni-field-error">{errors.password}</p>}
          </div>

          <button type="submit" className="alumni-login-btn" disabled={isSubmitting}>
            {isSubmitting ? "Authenticating..." : "Login"}
          </button>

          <div className="alumni-forgot-password">
            <Link to="/alumni-password-otp">Forgot Password?</Link>
          </div>

          <div className="alumni-register-text">
            Don't have an account? <Link to="/alumni-register">Register</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AlumniLogin;